import { Component, Injector, NgZone, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { StimulationChart } from '../stimulation-chart/stimulation-chart.component';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { BsModalService } from 'ngx-bootstrap/modal';
import { OrderServiceComponent } from '../order-service/order-service.component';

@Component({
  selector: 'app-chemotherapy-protocol',
  standalone: false,
  templateUrl: '../stimulation-chart/stimulation-chart.component.html',
  styleUrl: '../stimulation-chart/stimulation-chart.component.scss'
})
export class ChemotherapyProtocolComponent extends StimulationChart implements OnInit {
  gridData: any;
  fields: any;
  @Input() selectedData: any;
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public config: DialogConfig,
    public dialog: DialogRef,
    public alerts: AlertsService,
    public appService: AppService,
    public ngZone: NgZone,
    public loaders: LoaderService,
    public smartModalService: SmartModalService,
  ) {
    super(injector, router, route, modal, config, dialog, alerts, appService, ngZone, loaders, smartModalService);
  }

  ngOnInit(): void {
    this['input'] = "stimulation_chart";
    this.isorderBtnVisible = true;
    this.patient_protocol = true;
    if (this.selectedData) {
      localStorage.setItem("currentChildData", JSON.stringify(this.selectedData));
    }
    super.ngOnInit();
  }

  dataCall(filterData?: string): void {
    if (this.selectedData) {
      super.dataCall(filterData, `id:${this.selectedData.id},uhId:${this.selectedData.uhId}`, `GET_PATIENT_PROTOCOL_DETAILS`, `patient_assigned_protocols_details`, `total_sittings`);
    }
    // super.dataCall(filterData,`id:${this.route.snapshot.queryParams['key']},uhId:${this.route.snapshot.queryParams['uhId']}`,`GET_PATIENT_PROTOCOL_DETAILS`,`patient_assigned_protocols_details`,`total_sittings`);
  }

  orderMedication() {
    if (this.gridData["stimulationData"]?.resource.length) {
      let x: any = Object.keys(this.gridData["stimulationData"]?.resource[0]).map((key:any) => { if (this.gridData["stimulationData"]?.resource[0][key] == this.moment().format("DD/MM/YYYY")) return true; return false; })
      !x.includes(true) ? this.alerts.info("Services cannot be ordered as there is no sitting date today") : '';
      if (!x.includes(true)) {
        return;
      }
    }
    // let _ignoreDetailstype = ["Remarks", "Mark Done"];
    // let _data = this.apiData.filter((item) => item.start_date == this.moment().startOf('day').valueOf() && !_ignoreDetailstype.includes(item.details_type) && !item.order_sent);
    let _data = {uhId: this.patientDetails?.uhId, parent_id: this.patient_protocol_info.id, date: this.moment().startOf('day').valueOf()};

    let object = {
      "resource": "order_service",
      "action": "ADD",
      "application": "emr",
      "layout_type": "simple",
      "data": _data,
    }
    this.smartModalService.open(OrderServiceComponent, object, "Order Service", ModalSize.Lg).subscribe((data: any) => {
      if (data) {
        this.gridData = {};
        this.gridData.refresh = true;
        if (this.patient_protocol) {
          this.dataCallForProtocolHeader(this.patient_protocol_info)
          this.getToxicityData(this.patient_protocol_info);
        }
      }
    });
  }

  changaData(source, response, action, resourceMain, resource) {
    // if(resourceMain)
    if (!response) {
      return;
    }
    let payload = {};
    action = "ADD_FORM_DATA";
    resourceMain = "patient_assigned_protocols_details"
    if (resource == "surgery_care_plan_protocol") {
      let _arr = [];
      _arr.push(response.result)
      payload = response.result.no_of_days.map(day => ({
        ...response.result,
        "details_type": "Clinical Request",
        uhId: this.apiData[0].uhId,
        encounter_id: this.apiData[0].encounter_id,
        protocol_type: this.patient_protocol_info?.protocol_type,
        protocol_type_id: this.patient_protocol_info?.protocol_type_id,
        protocol_name: this.patient_protocol_info?.protocol_name,
        parent_id: this.apiData[0].parent_id,
        status: "Pending",
        stage: "Pending",
        protocol_id: this.patient_protocol_info?.protocol_id,
        no_of_sittings: day.text ? JSON.parse(day.text) : 0,
      }));
    } else if (resource == "clinical_care_plan_protocol") {
      payload = response.result.no_of_days.map(day => ({
        ...response.result,
        uhId: this.apiData[0].uhId,
        encounter_id: this.apiData[0].encounter_id,
        protocol_id: this.patient_protocol_info?.protocol_id,
        protocol_type: this.patient_protocol_info?.protocol_type,
        protocol_type_id: this.patient_protocol_info?.protocol_type_id,
        protocol_name: this.patient_protocol_info?.protocol_name,
        start_date: this.patient_protocol_info?.start_date,
        parent_id: this.apiData[0].parent_id,
        status: "Pending",
        stage: "Pending",
        "quantity": 1.0,
        "details_type": "Clinical Request",
        total_sittings: response.result.no_of_days.length,
        intent: this.patient_protocol_info?.intent,
        GTV: response.result.GTV,
        CTV: response.result.CTV,
        PTV: response.result.PTV,
        no_of_days: day.text ? JSON.parse(day.text) : 0,
        no_of_sittings: day.text ? JSON.parse(day.text) : 0
      }))
    } else if (resource == "medication_care_plan_protocol") {
      payload = response.result.no_of_days.map(day => ({
        ...response.result,
        uhId: this.apiData[0].uhId,
        encounter_id: this.apiData[0].encounter_id,
        protocol_id: this.patient_protocol_info?.protocol_id,
        protocol_type: this.patient_protocol_info?.protocol_type,
        protocol_type_id: this.patient_protocol_info?.protocol_type_id,
        protocol_name: this.patient_protocol_info?.protocol_name,
        start_date: this.patient_protocol_info?.start_date,
        parent_id: this.apiData[0].parent_id,
        status: "Pending",
        stage: "Pending",
        "quantity": 1.0,
        "details_type": "Medication Request",
        total_sittings: response.result.no_of_days.length,
        intent: this.patient_protocol_info?.intent,
        no_of_days: day.text ? JSON.parse(day.text) : 0,
        no_of_sittings: day.text ? JSON.parse(day.text) : 0,
      }))
    }
    
    
    // if(resource = "medication_care_plan_protocol"){
    this.formService.baseService.action(payload, action, "emr", resourceMain).subscribe(
      (res: any) => {
        if (res.errCode == 0) {
          this.dataCall();
          this.initializeFields(1);
        } else {
          this.alerts.error(res.message || "Something went wrong");
        }
      });
    // }
  }

}
